import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import axiosInstance from "../common/AxiosInstace";
import EndpointsGetter from '../common/EndpointsGetter';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
    SearchState,
    SortingState,
    SelectionState,
    PagingState,
    CustomPaging,
    FilteringState
} from '@devexpress/dx-react-grid';
import {
    Grid,
    Table as Table2,
    TableHeaderRow,
    TableFilterRow,
    TableSelection,
    PagingPanel,
    Toolbar as Toolbar2,
    SearchPanel,
    ColumnChooser,
    TableColumnVisibility,
    DragDropProvider,
    TableColumnReordering
} from '@devexpress/dx-react-grid-material-ui';
import debounce from 'lodash/debounce';
import CustomPagingPanel from '../common/data-table/CustomPagingPanel';
import { isAllowed, authRoles } from "../../../auth/auth";
import isEmpty from 'lodash/isEmpty';
import DatePickerFilterCell from '../common/data-table/DatePickerFilterCell';
import moment from 'moment';
import { TableComponent } from './TableComponent';

const styles = theme => ({
    root: {
        width: '100%'
    },
    table: {
        minWidth: 100,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    button: {
        'margin-right': theme.spacing.unit,
        height: 40
    },
    buttonGroup: {
        display: 'flex',
        'flex-direction': 'row',
        'justify-content': 'flex-start'
    },
    circularProgress: {
        'position': 'absolute', 'z-index': '1', 'margin-left': 'auto', 'margin-right': 'auto', 'top': '50%', 'left': '50%'
    }
});

class DataGroupsTable extends React.Component {
    constructor(props) {
        super(props);
        this.changeColumnOrder = this.changeColumnOrder.bind(this);
        this.commitChanges = this.commitChanges.bind(this);
        this.delayLoadData = debounce(this.delayLoadData, 650);
    }

    changeCurrentPage = currentPage => {
        let selection = [];
        this.setState({ currentPage, selection }, () => {
            this.loadData(currentPage, this.state.pageSize, this.state.filters, this.state.sorting, this.state.searchValue);
        });
    };

    changePageSize = pageSize => {
        let selection = [];
        this.setState({ pageSize, selection }, () => {
            this.loadData(this.state.currentPage, pageSize, this.state.filters, this.state.sorting, this.state.searchValue);
        });
    };
    changeSelection = selection => {
        let { rows } = this.state;
        this.setState({ selection });
        if (selection.length === 1) {
            this.setState({
                selectedGroupId: rows[selection].id,
                selectedDataGroup: rows[selection]
            });
        }
    };

    changeSorting = sorting => {
        this.setState({ sorting: sorting }, () => {
            this.loadData(this.state.currentPage, this.state.pageSize, this.state.filters, sorting, this.state.searchValue);
        });
    };
    changeSearchValue = value => {
        this.setState({ searchValue: value });
        this.delayLoadData(this.state.currentPage, this.state.pageSize, this.state.filters, this.state.sorting, value);
    };
    changeFilters = filters => {
        let selection = [];
        this.setState({ filters, selection });
        this.delayLoadData(this.state.currentPage, this.state.pageSize, filters, this.state.sorting, this.state.searchValue);
    };
    hiddenColumnNamesChange = (hiddenColumnNames) => {
        this.setState({ hiddenColumnNames });
    };

    state = {
        columns: [
            { name: 'name', title: 'Name' },
            { name: 'code', title: 'Code' },
            { name: 'status', title: 'Status' },
            { name: 'startDateFrom', title: 'Start' },
            { name: 'endDateTo', title: 'End' },
            { name: 'records', title: 'Records' }
        ],
        rows: [],
        data: this.props.dataList,
        totalCount: 0,
        currentPage: 0,
        pageSize: 10,
        pageSizes: [5, 10, 15],
        selection: [],
        sorting: [{ columnName: 'name', direction: 'asc' }],
        searchValue: '',
        filters: [],
        tableColumnExtensions: [],
        hiddenColumnNames: [],
        tableColumnVisibility: [
            { columnName: 'name', togglingEnabled: false }
        ],
        columnOrder: ['name', 'code', 'status', 'startDateFrom', 'endDateTo', 'records'],
        selectedGroupId: null,
        clonedGroupName: null,
        forbidAllActions: false,
        tableColumnFiltering: [
            { columnName: 'records', filteringEnabled: false }
        ],
        selectedDataGroup: {}
    };

    componentWillReceiveProps(nextProps) {
        let newState = { ...this.state };

        if (nextProps.dataList.totalPages !== 0 && nextProps.dataList.totalPages < this.state.currentPage + 1) {
            let currentPage = nextProps.dataList.totalPages - 1 < 0 ? 0 : nextProps.dataList.totalPages - 1;
            newState.currentPage = currentPage;
            this.changeCurrentPage(currentPage);
        }
        newState.data = nextProps.dataList;
        newState.rows = this.getRowsData(nextProps.dataList);
        newState.totalCount = nextProps.dataList.totalElements;

        if (nextProps.clonedGroupName !== null && typeof nextProps.clonedGroupName !== 'undefined' &&
            this.state.clonedGroupName !== nextProps.clonedGroupName) {
            newState.clonedGroupName = nextProps.clonedGroupName;
            newState.filters = [{
                columnName: "name",
                value: nextProps.clonedGroupName,
                operation: "contains"
            }];
            newState.selection = [];
        }

        this.setState(newState);
    }

    getRowsData(data) {
        let elements = data.elements;
        let rowsData = [];

        if (typeof elements !== 'undefined') {
            for (let i = 0; i < elements.length; i++) {
                rowsData.push({
                    id: elements[i].id,
                    name: elements[i].name,
                    code: elements[i].code,
                    status: elements[i].status,
                    startDateFrom: elements[i].startDate != null ? elements[i].startDate.split("T")[0] : '',
                    endDateTo: elements[i].endDate != null ? elements[i].endDate.split("T")[0] : '',
                    records: elements[i].records.toLocaleString("en-US")
                });
            }
        }

        return rowsData
    }

    changeColumnOrder(newOrder) {
        this.setState({ columnOrder: newOrder });
    }

    handleDeleteRow = () => {
        let { rows, selection } = this.state;
        const deletedSet = new Set(selection);
        rows = rows.filter(row => !deletedSet.has(row.id));
        for (let i = 0; i < rows.length; i++) {
            rows[i].id = i;
        }
        selection = [];
        this.setState({ rows, selection });
    };

    commitChanges({ added, changed, deleted }) {
        let { rows } = this.state;
        if (added) {
            const startingAddedId = rows.length > 0 ? rows[rows.length - 1].id + 1 : 0;
            rows = [
                ...rows,
                ...added.map((row, index) => ({
                    id: startingAddedId + index,
                    ...row,
                })),
            ];
        }
        if (changed) {
            rows = rows.map(row => (changed[row.id] ? { ...row, ...changed[row.id] } : row));
        }
        if (deleted) {
            const deletedSet = new Set(deleted);
            rows = rows.filter(row => !deletedSet.has(row.id));
        }
        this.setState({ rows });
    }

    delayLoadData = (currentPage, pageSize, filters, sorting, searchValue) => {
        this.loadData(currentPage, pageSize, filters, sorting, searchValue);
    };

    loadData = (currentPage, pageSize, filters, sorting, searchValue) => {
        let filterObject = {};
        let sortObject = {};
        if (sorting.length > 0) {
            if (sorting[0].columnName === "startDateFrom") {
                sortObject['startDate'] = sorting[0].direction.toUpperCase();
            } else if (sorting[0].columnName === "endDateTo") {
                sortObject['endDate'] = sorting[0].direction.toUpperCase();
            } else {
                sortObject[sorting[0].columnName] = sorting[0].direction.toUpperCase();
            }
        } else {
            sortObject["name"] = "ASC";
        }
        if (filters.length > 0) {
            for (let filter of filters) {
                //modifying dates here is a hack, however the date picker we are using is buggy, the package needs to be replaced and updated.
                filterObject[filter.columnName] =
                    filter.columnName === 'endDateTo' ?
                        moment(filter.value).endOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") :
                        filter.columnName === 'startDateFrom' ?
                            moment(filter.value).startOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : filter.value;
            }
        }
        if (searchValue !== '') {
            filterObject['keyword'] = searchValue;
        }
        this.props.getAllGroupsCallback({
            pageSize: pageSize,
            pageNumber: currentPage + 1,
            sort: sortObject,
            filters: filterObject
        }, false);
    };

    deleteDataGroup(id, dataOnly, recorderData) {
        let accessToken = localStorage.getItem("access_token");
        this.setState({ forbidAllActions: true });
        const deleteApiUrl = `${EndpointsGetter.getDataGroupEndpoint()}/${id}?dataOnly=${dataOnly}${recorderData ? `&recorderData=${recorderData}` : ``}`;
        axiosInstance.delete(deleteApiUrl, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(response => {
                this.setState({ forbidAllActions: false });
                this.setState(this);

                if (!response.data.deleted) {
                    this.props.messageCallback({
                        message: "Unable to delete the data group in appropriate time.",
                        shouldGetAllGroups: false
                    });
                } else {
                    let oldState = { ...this.state };
                    let shouldGetAllGroups = false;
                    if (!dataOnly) {
                        oldState.selection = [];
                        shouldGetAllGroups = false;
                    }
                    this.props.messageCallback({
                        message: "Delete process finished with success.",
                        shouldGetAllGroups: shouldGetAllGroups
                    });

                    if (dataOnly) {
                        // stay on current page - just refresh it
                        oldState.selection = [];
                        this.loadData(this.state.currentPage, this.state.pageSize, this.state.filters, this.state.sorting, this.state.searchValue);
                    } else {
                        // returns to previous page (if there is) when deleting last data group from current page
                        if ((this.state.rows.length === 1 && this.state.currentPage === 0) || (this.state.rows.length > 1)) {
                            this.loadData(this.state.currentPage, this.state.pageSize, this.state.filters, this.state.sorting, this.state.searchValue);
                        } else {
                            this.loadData(this.state.currentPage - 1, this.state.pageSize, this.state.filters, this.state.sorting, this.state.searchValue);
                        }
                    }

                    this.setState(oldState);
                }
            })
            .catch(error => {
                this.setState({ selection: [], forbidAllActions: false });
                this.loadData(this.state.currentPage, this.state.pageSize, this.state.filters, this.state.sorting, this.state.searchValue);
                this.props.errorCallback(error);
            });
    }

    deleteMultipleDataGroups = (dataOnly, recorderData) => {
        let selection = [...this.state.selection];

        const { rows } = this.state,
            dataGroupIds = selection.map(selection => ({ "id": rows[selection].id })),
            accessToken = localStorage.getItem("access_token");

        this.setState({ forbidAllActions: true });
        axiosInstance.delete(`${EndpointsGetter.getDataGroupEndpoint()}/multiDelete`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            },
            data: {
                "dataOnly": dataOnly,
                "recorderData": recorderData,
                "groupsToDelete": dataGroupIds
            }
        })
            .then(response => {
                this.setState({ forbidAllActions: false });
                if (isEmpty(response.data.unsuccessfullyDeleted) && !isEmpty(response.data.successfullyDeleted)) {
                    this.props.messageCallback({
                        message: "Delete process finished with success.",
                        shouldGetAllGroups: false
                    });
                    this.setState({ selection: [] }, () => this.loadData(this.state.currentPage, this.state.pageSize, this.state.filters, this.state.sorting, this.state.searchValue));
                } else {
                    const unsuccessfulDataGroupsIndexes = response.data.unsuccessfullyDeleted.map(el => rows.findIndex(row => row.id === el.id));
                    unsuccessfulDataGroupsIndexes.forEach(index => {
                        selection = selection.filter(el => el !== index)
                    });
                    this.setState({ selection: selection }, () => {
                        this.loadData(this.state.currentPage, this.state.pageSize, this.state.filters, this.state.sorting, this.state.searchValue);
                    });
                    this.props.messageCallback({
                        message: `Delete process was unsuccessful for data groups: ${this.getDataGroupNames(dataGroupIds, rows)}`,
                        shouldGetAllGroups: false
                    })
                }
            })
            .catch(error => {
                this.setState({ selection: [], forbidAllActions: false });
                this.loadData(this.state.currentPage, this.state.pageSize, this.state.filters, this.state.sorting, this.state.searchValue);
                this.props.errorCallback(error);
            });
    }

    getDataGroupNames = (ids, rows) => {
        const datagroups = ids.map(id => rows.find(row => { return id.id === row.id })),
            names = datagroups.map(datagroup => datagroup.name);

        return names.length > 1 ? names.join(', ') : names.join();
    }

    cloneDataGroup(id) {
        let accessToken = localStorage.getItem("access_token");
        axiosInstance.post(EndpointsGetter.getDataGroupEndpoint() + '/' + id, {}, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(response => {
                let oldState = { ...this.state };
                let filterObject = {
                    pageSize: 10,
                    pageNumber: 1,
                    sort: { "name": "ASC" },
                    filters: { "name": response.data.name }
                };
                let gridFilterValue = {
                    columnName: "name",
                    value: response.data.name,
                    operation: "contains"
                };
                this.props.messageCallback({
                    message: "Group has been cloned successfully",
                    shouldGetAllGroups: false
                });
                this.props.getAllGroupsCallback(filterObject, false);
                oldState.filters = [gridFilterValue];
                oldState.selection = [];
                this.setState(oldState);
            })
            .catch(error => {
                this.props.errorCallback(error);
            });
    }

    renderFilterCell = (props) => {
        const { column } = props;

        if (column.name === 'startDateFrom' || column.name === 'endDateTo') {
            const { filters } = this.state,
                dateRange = this.getDateRange(column, filters);

            return <DatePickerFilterCell
                {...props}
                minDate={dateRange.minDate}
                maxDate={dateRange.maxDate}
            />;
        }

        return <TableFilterRow.Cell {...props} />;
    }

    getDateRange = (column, filters) => {
        let minDate = new Date('1900-01-01').getTime(),
            maxDate = new Date('2100-01-01').getTime();
        if (column.name === 'startDateFrom') {
            maxDate = !isEmpty(filters) && filters.find(filter => filter.columnName === 'endDateTo') ?
                filters.find(filter => filter.columnName === 'endDateTo').value : new Date('2100-01-01').getTime();
        } else {
            minDate = !isEmpty(filters) && filters.find(filter => filter.columnName === 'startDateFrom') ?
                filters.find(filter => filter.columnName === 'startDateFrom').value : new Date('1900-01-01').getTime();
        }

        return {
            minDate: minDate,
            maxDate: maxDate
        }
    }

    render() {
        const changed = this.state.changed ? 'changed' : 'unchanged';
        const { classes, user } = this.props;
        const {
            columns, pageSize, pageSizes, currentPage, selection, searchValue,
            filters, tableColumnExtensions, hiddenColumnNames, tableColumnVisibility, columnOrder, totalCount, tableColumnFiltering, selectedGroupId, selectedDataGroup,
            sorting
        } = this.state;

        return (
            <div className={classes.root} >
                {this.state.forbidAllActions ? <CircularProgress className={classNames(classes.circularProgress, classes.progress)} color="secondary" /> : null}
                < div style={{
                    pointerEvents: this.state.forbidAllActions ? 'none' : 'auto', 'filter': this.state.forbidAllActions ? 'blur(1px)' : 'blur(0px)'
                }}>
                    <div className={classes.buttonGroup}>
                        {isAllowed(user, authRoles.exceptViewer) ? (
                            <Fragment>
                                <Link to={{
                                    pathname: '/create-group'
                                }}>
                                    <button className={classNames(classes.button, "btn btn-default")} type="submit">New</button>
                                </Link>
                                {selection.length !== 1 ?
                                    <div>
                                        <button className={classNames(classes.button, "btn btn-default")} type="submit" disabled>
                                            Edit
                                        </button>
                                        <button className={classNames(classes.button, "btn btn-default")} type="submit" disabled>
                                            Query
                                        </button>
                                        <button className={classNames(classes.button, "btn btn-default")} type="submit" disabled>
                                            Clone
                                        </button>
                                    </div>
                                    :
                                    <div>
                                        <Link to={{
                                            pathname: '/edit-group/' + selectedGroupId
                                        }}>
                                            <button className={classNames(classes.button, "btn btn-default")} type="submit">
                                                Edit
                                            </button>
                                        </Link>
                                        {
                                            selectedDataGroup.status === "active" && (selectedDataGroup.records !== null && parseInt(selectedDataGroup.records) > 0) ?
                                                <Link to={{
                                                    pathname: '/query-group/' + selectedGroupId
                                                }}>
                                                    <button className={classNames(classes.button, "btn btn-default")} type="submit">
                                                        Query
                                                    </button>
                                                </Link> :
                                                <button className={classNames(classes.button, "btn btn-default")} type="submit"
                                                    disabled>
                                                    Query
                                                </button>
                                        }
                                        <button className={classNames(classes.button, "btn btn-default")} type="submit"
                                            onClick={(e) => this.cloneDataGroup(selectedGroupId)}>Clone
                                        </button>
                                    </div>
                                }
                                {
                                    selection.length > 0 ? (
                                        <div className="btn-group" style={{ marginRight: 10 }}>
                                            <button
                                                className={classNames(classes.button, "btn btn-default dropdown-toggle trigger-btn")}
                                                type="submit" data-toggle="dropdown">Delete <span className="caret"></span></button>
                                            <ul className="dropdown-menu dropdown-menu-right">
                                                <li>
                                                    <a href="#deleteDataModal" data-target="#deleteDataModal" data-toggle="modal"
                                                        onClick={(e) => {
                                                            let modal = document.getElementById("deleteDataModal");
                                                            document.body.appendChild(modal);
                                                        }}>Only group's data</a>
                                                </li>
                                                <li>
                                                    <a href="#deleteGroupModal" data-target="#deleteGroupModal" data-toggle="modal"
                                                        onClick={(e) => {
                                                            let modal = document.getElementById("deleteGroupModal");
                                                            document.body.appendChild(modal);
                                                        }}>All (data and configuration)</a>
                                                </li>
                                                <li>
                                                    <a href="#deleteDataCompletelyModal" data-target="#deleteDataCompletelyModal" data-toggle="modal"
                                                        onClick={(e) => {
                                                            let modal = document.getElementById('deleteDataCompletelyModal');
                                                            document.body.appendChild(modal);
                                                        }}>Data group's data including replay data</a>
                                                </li>
                                            </ul>
                                        </div>
                                    ) : (
                                            <button className={classNames(classes.button, "btn btn-default")} type="submit" disabled>
                                                Delete <span className="caret"></span>
                                            </button>
                                        )
                                }
                            </Fragment>
                        ) : (
                                <Fragment>
                                    {selection.length !== 1 ? (
                                        <button className={classNames(classes.button, "btn btn-default")} type="submit" disabled>
                                            Query
                                        </button>
                                    ) : (
                                            <Fragment>
                                                {
                                                    selectedDataGroup.status === "active" && (selectedDataGroup.records !== null && parseInt(selectedDataGroup.records) > 0) ?
                                                        <Link to={{
                                                            pathname: '/query-group/' + selectedGroupId
                                                        }}>
                                                            <button className={classNames(classes.button, "btn btn-default")} type="submit">
                                                                Query
                                                            </button>
                                                        </Link> :
                                                        <button className={classNames(classes.button, "btn btn-default")} type="submit"
                                                            disabled>
                                                            Query
                                                        </button>
                                                }
                                            </Fragment>
                                        )}
                                </Fragment>
                            )}
                    </div>
                    <div id="deleteDataModal" className="modal fade" role="dialog">
                        <div className="modal-dialog modal-confirm">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Are you sure?
                                        <button type="button" className="close" data-dismiss="modal" aria-hidden="true">
                                            &times;
                                        </button>
                                    </h4>
                                </div>
                                <div className="modal-body">
                                    <p>
                                        {
                                            selection.length > 1 ?
                                                'You are about to delete only the data of the selected data groups. This process cannot be undone.' :
                                                'You are about to delete only the data of this data group. This process cannot be undone.'
                                        }
                                    </p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-info" data-dismiss="modal">Cancel</button>
                                    <button type="button" className="btn btn-danger"
                                        onClick={(e) => selection.length > 1 ? this.deleteMultipleDataGroups(true, false) : this.deleteDataGroup(selectedGroupId, true, false)}
                                        data-dismiss="modal">
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="deleteGroupModal" className="modal fade" role="dialog">
                        <div className="modal-dialog modal-confirm">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Are you sure?
                                        <button type="button" className="close" data-dismiss="modal" aria-hidden="true">
                                            &times;
                                        </button>
                                    </h4>
                                </div>
                                <div className="modal-body">
                                    <p>
                                        {
                                            selection.length > 1 ?
                                                'You are about to delete the selected data groups (data and configuration). This process cannot be undone.' :
                                                'You are about to delete the whole data group (data and configuration). This process cannot be undone.'
                                        }
                                    </p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-info" data-dismiss="modal">Cancel</button>
                                    <button type="button" className="btn btn-danger"
                                        onClick={(e) => selection.length > 1 ? this.deleteMultipleDataGroups(false, false) : this.deleteDataGroup(selectedGroupId, false, false)}
                                        data-dismiss="modal">
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="deleteDataCompletelyModal" className="modal fade" role="dialog">
                        <div className="modal-dialog modal-confirm">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Are you sure?
                                        <button type="button" className="close" data-dismiss="modal" aria-hidden="true">
                                            &times;
                                        </button>
                                    </h4>
                                </div>
                                <div className="modal-body">
                                    <p>
                                        {
                                            selection.length > 1 ?
                                                'You are about to delete the data of the selected groups completely including stored replay entries. This process cannot be undone.' :
                                                `You are about to delete this data group's data completely including stored replay entries. This
                                                process cannot be undone.`
                                        }
                                    </p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-info" data-dismiss="modal">
                                        Cancel
                                    </button>
                                    <button type="button" className="btn btn-danger"
                                        onClick={(e) => selection.length > 1 ? this.deleteMultipleDataGroups(true, true) : this.deleteDataGroup(selectedGroupId, true, true)}
                                        data-dismiss="modal">
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <Paper className="total-label">
                        {/*<EnhancedTableToolbar numSelected={selection.length}/>*/}
                        <Grid
                            rows={this.state.rows}
                            columns={columns}
                        >
                            {/* <EditingState
                                onCommitChanges={this.commitChanges}
                            /> */}
                            <SearchState
                                value={searchValue}
                                onValueChange={this.changeSearchValue}
                            />
                            <SelectionState
                                selection={selection}
                                onSelectionChange={this.changeSelection}
                            />
                            <FilteringState
                                filters={filters}
                                onFiltersChange={this.changeFilters}
                                columnExtensions={tableColumnFiltering}
                            />
                            <PagingState
                                currentPage={currentPage}
                                onCurrentPageChange={this.changeCurrentPage}
                                pageSize={pageSize}
                                onPageSizeChange={this.changePageSize}
                            />
                            <CustomPaging
                                totalCount={totalCount}
                            />
                            <SortingState
                                onSortingChange={this.changeSorting}
                                sorting={sorting}
                            />
                            {/*<IntegratedSorting />*/}
                            {/* <IntegratedSelection /> */}
                            {/*<IntegratedFiltering />*/}
                            <DragDropProvider />
                            <Table2
                                columnExtensions={tableColumnExtensions}
                                tableComponent={TableComponent}
                            />
                            <TableColumnReordering
                                order={columnOrder}
                                onOrderChange={this.changeColumnOrder}
                            />
                            <TableHeaderRow showSortingControls />
                            <TableColumnVisibility
                                hiddenColumnNames={hiddenColumnNames}
                                onHiddenColumnNamesChange={this.hiddenColumnNamesChange}
                                columnExtensions={tableColumnVisibility}
                            />
                            <Toolbar2 />
                            <SearchPanel />
                            <ColumnChooser />
                            <TableFilterRow
                                cellComponent={this.renderFilterCell}
                            />
                            <TableSelection selectByRowClick />
                            <PagingPanel
                                pageSizes={pageSizes}
                                containerComponent={() => <CustomPagingPanel
                                    pageSizes={pageSizes}
                                    pageSize={pageSize}
                                    onChangePageSize={this.changePageSize}
                                    currentPage={currentPage}
                                    totalCount={totalCount}
                                    onCurrentPageChange={this.changeCurrentPage}
                                />}
                            />
                        </Grid>
                    </Paper>
                </div >
            </div >
        );
    }
}

DataGroupsTable.propTypes = {
    classes: PropTypes.object.isRequired,
    user: PropTypes.object
};

export default withStyles(styles)(DataGroupsTable);



// WEBPACK FOOTER //
// ./src/main/content/data-groups/DataGroupsTable.js